import React from 'react';
import { useTranslation } from 'react-i18next';

interface ViewGoalTitleProps {
  title: string;
}

export const ViewGoalTitle: React.FC<ViewGoalTitleProps> = ({ title }) => {
  const { t } = useTranslation('goals');

  return (
    <div>
      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 block">
        {t('titleLabel')}
      </label>
      <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
    </div>
  );
};
